export function assignLocation(path: string): void {
  window.location.assign(path);
}
